import { FeedbackOutlined } from "@mui/icons-material";
import { Button, useTheme } from "@mui/material";

import Modal, { ModalProps } from "fond/widgets/Modal";

import { HubSpotForm, HubSpotFormProps } from "./HubSpotForm";

type HubSpotModalProps = HubSpotFormProps & Pick<ModalProps, "onClose" | "header" | "headerSubtitle" | "headerIcon">;

export const HubSpotModal: React.FC<HubSpotModalProps> = ({
  onClose,
  header,
  headerSubtitle,
  headerIcon = <FeedbackOutlined />,
  ...formProps
}: HubSpotModalProps) => {
  const theme = useTheme();

  return (
    <Modal
      header={header}
      headerSubtitle={headerSubtitle}
      headerIcon={headerIcon}
      variant="primary"
      open
      content={<HubSpotForm {...formProps} />}
      onClose={onClose}
      DialogContentProps={{
        sx: {
          // necessary to prevent initial scrollbars
          padding: "0 0 8px 0 !important",
        },
      }}
      PaperProps={{
        style: {
          width: "60vw",
          maxWidth: theme.breakpoints.values.md,
        },
      }}
      DialogActionsProps={{ sx: { paddingTop: "4px !important" } }}
      actions={<Button onClick={onClose}>Close</Button>}
    />
  );
};
